import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy, ViewRef, ViewChild, ElementRef, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, AfterViewInit, NgZone } from '@angular/core';
import { fromEvent } from 'rxjs';
import { BaseChartDirective } from 'ng2-charts';
import { Column } from '../../models/column';
import { MathFunction } from '../../models/mathfunction';
import { ValueField } from '../../models/valuefield';
import { Distinct } from '../../models/distinct';
import { AggrPipe } from '../../pipe/aggr.pipe';
import { MDGFilterComponent } from '../Filter/MDG.Filter';
import { FormatPipe } from '../../pipe/format.pipe';
import { MDGDetailComponent } from '../detail/MDG.Detail';
import { SortPipe } from '../../pipe/sort.pipe';
import { MDGDateFilterComponent } from '../Filter/MDG.DateFilter';
import { HelperService } from '../../Services/Helper.Service';
import { MDGFormatterComponent } from '../toolbar/mdg.formatter';
import { FieldStyle } from '../../models/fieldstyle';
import { PivotSave } from '../../models/pivotsave';

declare const pdfMake: any;

@Component({
  selector: 'mdg-pivotdrawer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<mdg-filter #filter (updateFilters)='onUpdateFilters($event)'></mdg-filter>
  <mdg-formatter #formatter [formattedFields]='formattedFields' (updateFormat)='onUpdateFormatter($event)'>
  </mdg-formatter>
  <mdg-datefilter #datefilter (updateFilters)='onUpdateFilters($event)'></mdg-datefilter>
  <mdg-detail #detail [columns]='columns' [selectedColumns]='selectedColumns' [selectedRows]='selectedRows' [selectedValues]='selectedValues'></mdg-detail>
  <div class="mdg-filter-items-container" *ngIf="selectedFColumns.length > 0 && !processingData && chartType === 'grid' && pivotConfig.showAdditionalFilter">
      <div class='mdg-filter-title'>
          <h3>Filters : </h3>
      </div>
      <div *ngFor="let col of selectedFColumns" class='btn btn-sm bn-default mdg-filter-item' (click)='showAddFilter(col)'>
          <span class="mdg-filter pull-left" [style.font-size]='col.header.fontSize + "px"' [style.font-style]='col.header.fontStyle' [style.font-weight]='col.header.fontWeight' [class.text-right]='col.header.textAlign === "right"' [class.text-center]='col.header.textAlign === "center"'>{{col.displayName}}</span>
          <i class="mdg-filter fa fa-filter"></i>
      </div>
  </div>
  <div class='mdg-pivot-container-div data-loader-wrap' [class.mdg-filter-visible]='selectedFColumns.length > 0'>
      <div *ngIf="processingData && chartType === 'grid'" [style.height]='tableHeight'>
          <div *ngIf="processingData" class="data-loader">
              <div class="lds-css">
                  <div class="lds-double-ring">
                      <div></div>
                      <div></div>
                  </div>
                  <div class="clearfix"></div>
              </div>
          </div>
      </div>
      <table [class.hidden]="data.length <= 0 || processingData || chartType !== 'grid' || (rowKeys.length <= 0 && colKeys.length <= 0)">
          <tr>
              <td>
                  <table>
                      <tr>
                          <td>
                              <table class="mdg-pivot">
                                  <thead>
                                      <tr>
                                          <th class="mdg-sr-cell"></th>
                                          <ng-container *ngIf="selectedRows.length < 6">
                                              <th class="text-center" *ngFor="let col of selectedRows; let i = index">{{i + 1}}</th>
                                              <th class="text-center" *ngIf="selectedColumns.length > 0">
                                                  {{selectedRows.length + 1}}</th>
                                          </ng-container>
                                      </tr>
                                      <tr *ngFor="let col of selectedColumns; let j = index">
                                          <th class="mdg-sr-cell">{{j + 1}}</th>
                                          <ng-container *ngIf="selectedRows.length < 6">
                                              <th class="title-cell" *ngIf="j === 0 && selectedRows.length !== 0" colSpan="{{selectedRows.length}}" rowSpan="{{selectedColumns.length}}">
                                              </th>
                                              <th class="title-cell" [style.font-size]='col.header.fontSize + "px"' [style.font-style]='col.header.fontStyle' [style.font-weight]='col.header.fontWeight' [title]="col.displayName">
                                                  <span class="mdg-filter" [class.text-right]='col.header.textAlign === "right"' [class.text-center]='col.header.textAlign === "center"'>{{col.displayName}}</span>
                                                  <i *ngIf="pivotConfig.showColumnFilter" class="mdg-filter fa fa-filter" (click)='showFilter(col)'></i>
                                              </th>
                                          </ng-container>
                                      </tr>
                                      <tr *ngIf="selectedRows.length !== 0">
                                          <th class="mdg-sr-cell">{{selectedColumns.length + 1}}</th>
                                          <ng-container *ngIf="selectedRows.length < 6">
                                              <th class="title-cell" [style.font-size]='col.header.fontSize + "px"' [style.font-style]='col.header.fontStyle' [style.font-weight]='col.header.fontWeight' *ngFor="let col of selectedRows; let j = index" [title]="col.displayName">
                                                  <span class="mdg-filter" [class.text-right]='col.header.textAlign === "right"' [class.text-center]='col.header.textAlign === "center"'>{{col.displayName}}</span>
                                                  <i *ngIf="pivotConfig.showColumnFilter" class="mdg-filter fa fa-filter" (click)='showFilter(col)'></i>
                                              </th>
                                              <ng-container *ngIf="selectedColumns.length > 0">
                                                  <th class="title-cell"></th>
                                              </ng-container>
                                          </ng-container>
                                      </tr>
                                      <tr *ngIf="selectedRows.length === 0 && valLength > 1">
                                          <th class="mdg-sr-cell">{{selectedColumns.length + 1}}</th>
                                          <ng-container *ngIf="selectedColumns.length > 0 && selectedRows.length < 6">
                                              <th class="title-cell"></th>
                                          </ng-container>
                                      </tr>
                                  </thead>
                              </table>
                          </td>
                          <td>
                              <div #hScroll class="pivot-values right-10 border-right-d9d9d9" [style.left]='getLeft()'>
                                  <table class="mdg-pivot right-buffer-10">
                                      <thead>
                                          <tr>
                                              <ng-container *ngIf="selectedRows.length > 5">
                                                  <th class="text-center" *ngFor="let col of selectedRows; let i = index">
                                                      {{i + 1}}</th>
                                                  <th class="text-center" *ngIf="selectedColumns.length > 0">
                                                      {{selectedRows.length + 1}}</th>
                                              </ng-container>
                                              <ng-container *ngIf="selectedRows.length < 6">
                                                  <th class="width-0 no-padding no-border"></th>
                                              </ng-container>
                                              <ng-container *ngFor="let colKey of colKeys; let i = index">
                                                  <th class="text-center" *ngFor="let col of selectedValues; let j = index;">
                                                      {{selectedRows.length + 2 + (selectedValues.length * i) + j}}</th>
                                              </ng-container>
                                              <th class="text-center" *ngFor="let col of selectedValues; let j = index;">
                                                  {{selectedRows.length + 2 + (colKeys.length * selectedValues.length) + j}}
                                              </th>
                                          </tr>
                                          <tr *ngFor="let col of selectedColumns; let j = index">
                                              <ng-container *ngIf="selectedRows.length > 5">
                                                  <th class="title-cell" *ngIf="j === 0 && selectedRows.length !== 0" colSpan="{{selectedRows.length}}" rowSpan="{{selectedColumns.length}}"></th>
                                                  <th class="title-cell" [title]="col.displayName">
                                                      <span class="mdg-filter" [style.font-size]='col.header.fontSize + "px"' [style.font-style]='col.header.fontStyle' [style.font-weight]='col.header.fontWeight' [class.text-right]='col.header.textAlign === "right"' [class.text-center]='col.header.textAlign === "center"'>{{col.displayName}}</span>
                                                      <i *ngIf="pivotConfig.showColumnFilter" class="mdg-filter fa fa-filter" (click)='showFilter(col)'></i>
                                                  </th>
                                              </ng-container>
                                              <ng-container *ngIf="selectedRows.length < 6">
                                                  <th class="width-0 no-padding no-border"></th>
                                              </ng-container>
                                              <ng-container *ngFor="let colKey of colKeys; let i = index">
                                                  <th class="title-value title-format" [ngStyle]='getColHeaderStyle(colKey, j)' *ngIf="getSpanSize(colKeys, i, j) !== -1" [colSpan]='getSpanSize(colKeys, i, j) * valLength' title="{{getHeaderText(colKey[j]) | format:col}}" (click)='showColFormatter(col, colKey, j)'
                                                      [rowSpan]='(j === (selectedColumns.length - 1) && selectedRows.length !== 0 && valLength === 1) ? 2 : 1 '>{{getHeaderText(colKey[j]) | format:col}}
                                                  </th>
                                              </ng-container>
                                              <ng-container *ngIf="j === 0">
                                                  <th class="title-value title-format" *ngFor="let sVal of selectedValues" title='{{getHeaderText(sVal.column.valueField ? sVal.column.displayName : "Total " + sVal.mathFn.Name + " of " + sVal.column.displayName)}}'
                                                      [rowSpan]="selectedColumns.length + (selectedRows.length === 0 && valLength <= 1 ? 0 : 1)" (click)='showFormatter(sVal.column, sVal.column.valueField ? sVal.column.displayName : "Total " + sVal.mathFn.Name + " of " + sVal.column.displayName)'
                                                      [ngStyle]='getHeaderStyle(sVal.column.valueField ? sVal.column.displayName : "Total " + sVal.mathFn.Name + " of " + sVal.column.displayName)'>
                                                      {{getHeaderText(sVal.column.valueField ? sVal.column.displayName : "Total " + sVal.mathFn.Name + " of " + sVal.column.displayName)}}
                                                  </th>
                                              </ng-container>
                                          </tr>
                                          <tr *ngIf="selectedRows.length !== 0">
                                              <ng-container *ngIf="selectedRows.length > 5">
                                                  <th class="title-cell" *ngFor="let col of selectedRows; let j = index" [title]="col.displayName">
                                                      <span class="mdg-filter" [style.font-size]='col.header.fontSize + "px"' [style.font-style]='col.header.fontStyle' [style.font-weight]='col.header.fontWeight' [class.text-right]='col.header.textAlign === "right"' [class.text-center]='col.header.textAlign === "center"'>{{col.displayName}}</span>
                                                      <i *ngIf="pivotConfig.showColumnFilter" class="mdg-filter fa fa-filter" (click)='showFilter(col)'></i>
                                                  </th>
                                                  <ng-container *ngIf="selectedColumns.length > 0">
                                                      <th class="title-cell"></th>
                                                  </ng-container>
                                              </ng-container>
                                              <ng-container *ngIf="selectedRows.length < 6">
                                                  <th class="width-0 no-padding no-border"></th>
                                              </ng-container>
                                              <ng-container *ngIf="selectedColumns.length === 0">
                                                  <th class="title-value title-format" title='{{getHeaderText(sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)}}' [ngStyle]='getHeaderStyle(sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)'
                                                      *ngFor="let sVal of selectedValues" (click)='showFormatter(sVal.column, sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)'>
                                                      {{getHeaderText(sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)}}
                                                  </th>
                                              </ng-container>
                                              <ng-container *ngIf="valLength > 1">
                                                  <ng-container *ngFor="let colKey of colKeys">
                                                      <th class="title-value title-format" title='{{getHeaderText(sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)}}' [ngStyle]='getHeaderStyle(sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)'
                                                          *ngFor="let sVal of selectedValues" (click)='showFormatter(sVal.column, sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)'>
                                                          {{getHeaderText(sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)}}
                                                      </th>
                                                  </ng-container>
                                              </ng-container>
                                          </tr>
                                          <tr *ngIf="selectedRows.length === 0 && valLength > 1">
                                              <ng-container *ngIf="selectedRows.length > 5">
                                                  <ng-container *ngIf="selectedColumns.length > 0">
                                                      <th class="title-cell"></th>
                                                  </ng-container>
                                              </ng-container>
                                              <ng-container *ngIf="selectedRows.length < 6">
                                                  <th class="width-0 no-padding no-border"></th>
                                              </ng-container>
                                              <ng-container *ngIf="valLength > 1">
                                                  <ng-container *ngFor="let colKey of colKeys">
                                                      <th class="title-value title-format" title='{{getHeaderText(sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)}}' [ngStyle]='getHeaderStyle(sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)'
                                                          *ngFor="let sVal of selectedValues" (click)='showFormatter(sVal.column, sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)'>
                                                          {{getHeaderText(sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)}}
                                                      </th>
                                                  </ng-container>
                                              </ng-container>
                                          </tr>
                                      </thead>
                                  </table>
                              </div>
                          </td>
                      </tr>
                  </table>
              </td>
          </tr>
          <tr>
              <td>
                  <table>
                      <tr>
                          <td>
                              <div #vScrollL class="pivot-values" [style.top]='getTop()'>
                                  <table class="mdg-pivot bottom-buffer-10">
                                      <thead>
                                          <tr>
                                              <th class="mdg-sr-cell height-0 no-padding no-border"></th>
                                              <ng-container *ngIf="selectedRows.length && selectedRows.length < 6">
                                                  <th class="height-0 no-padding no-border" *ngFor="let col of selectedRows; let i = index"></th>
                                                  <th class="height-0 no-padding no-border"></th>
                                              </ng-container>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr *ngFor="let rowKey of rowKeys; let i = index;">
                                              <th class="mdg-sr-cell">{{selectedColumns.length + 2 + i}}</th>
                                              <ng-container *ngIf="selectedRows.length && selectedRows.length < 6">
                                                  <ng-container *ngFor="let rVal of rowKey; let j = index">
                                                      <th class="title-value" [style.font-size]='selectedRows[j].cell.fontSize + "px"' [style.font-style]='selectedRows[j].cell.fontStyle' [style.font-weight]='selectedRows[j].cell.fontWeight' [class.text-right]='selectedRows[j].cell.textAlign === "right"'
                                                          [class.text-center]='selectedRows[j].cell.textAlign === "center"' *ngIf="getSpanSize(rowKeys, i, j) !== -1" title='{{rowKey[j] | format:selectedRows[j]}}' [rowSpan]='getSpanSize(rowKeys, i, j)' [colSpan]='j === selectedRows.length - 1 && selectedColumns.length !== 0 ? 2 : 1'>
                                                          {{rowKey[j] | format:selectedRows[j]}}</th>
                                                  </ng-container>
                                              </ng-container>
                                          </tr>
                                          <tr>
                                              <th class="mdg-sr-cell border-bottom-d9d9d9" *ngIf="selectedValues.length > 0">{{selectedColumns.length + 2 + rowKeys.length}}
                                              </th>
                                              <ng-container *ngIf="selectedRows.length && selectedRows.length < 6">
                                                  <th title="{{getHeaderText('Grand Total')}}" [style.font-size]='selectedRows[0].cell.fontSize + "px"' [style.font-style]='selectedRows[0].cell.fontStyle' [style.font-weight]='selectedRows[0].cell.fontWeight' [class.text-right]='selectedRows[0].cell.textAlign === "right"'
                                                      [class.text-center]='selectedRows[0].cell.textAlign === "center"' class="title-format border-bottom-d9d9d9" *ngIf="selectedValues.length > 0" (click)="showGrandTotalFormatter('Grand Total')" [colSpan]="selectedRows.length + (selectedColumns.length === 0 ? 0 : 1)"
                                                      [ngStyle]="getGrandTotalStyle('Grand Total')">{{getHeaderText('Grand Total')}}
                                                  </th>
                                              </ng-container>
                                              <ng-container *ngIf="selectedRows.length === 0 && selectedColumns.length > 0 && selectedValues.length > 0">
                                                  <th title="{{getHeaderText('Grand Total')}}" [style.font-size]='selectedColumns[0].cell.fontSize + "px"' [style.font-style]='selectedColumns[0].cell.fontStyle' [style.font-weight]='selectedColumns[0].cell.fontWeight' [class.text-right]='selectedColumns[0].cell.textAlign === "right"'
                                                      [class.text-center]='selectedColumns[0].cell.textAlign === "center"' (click)="showGrandTotalFormatter('Grand Total')" class="title-format border-bottom-d9d9d9" [colSpan]="selectedColumns.length" [ngStyle]="getGrandTotalStyle('Grand Total')">{{getHeaderText('Grand Total')}}
                                                  </th>
                                              </ng-container>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </td>
                          <td>
                              <div #vScrollR class="pivot-values" [style.top]='getTop()' [style.left]='getLeft()'>
                                  <table class="mdg-pivot">
                                      <thead>
                                          <tr>
                                              <ng-container *ngIf="selectedRows.length > 5">
                                                  <th class="height-0 no-padding no-border" *ngFor="let col of selectedRows; let i = index"></th>
                                                  <th class="height-0 no-padding no-border" *ngIf="selectedColumns.length"></th>
                                              </ng-container>
                                              <ng-container *ngIf="selectedRows.length < 6">
                                                  <th class=" mdg-sr-cell height-0 width-0 no-padding no-border"></th>
                                              </ng-container>
                                              <ng-container *ngFor="let colKey of colKeys; let i = index">
                                                  <th class="height-0 no-padding no-border" *ngFor="let col of selectedValues; let j = index;"></th>
                                                  <th class="height-0 no-padding no-border" *ngIf="selectedValues.length == 0"></th>
                                              </ng-container>
                                              <th class="height-0 no-padding no-border" *ngFor="let col of selectedValues; let j = index;"></th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr *ngFor="let rowKey of rowKeys; let i = index;">
                                              <ng-container *ngIf="selectedRows.length && selectedRows.length > 5">
                                                  <ng-container *ngFor="let rVal of rowKey; let j = index">
                                                      <th class="title-value" [style.font-size]='selectedRows[j].fontSize + "px"' [style.font-style]='selectedRows[j].fontStyle' [style.font-weight]='selectedRows[j].fontWeight' [class.text-right]='selectedRows[j].textAlign === "right"' [class.text-center]='selectedRows[j].textAlign === "center"'
                                                          *ngIf="getSpanSize(rowKeys, i, j) !== -1" title='{{rowKey[j] | format:selectedRows[j]}}' [rowSpan]='getSpanSize(rowKeys, i, j)' [colSpan]='j === selectedRows.length - 1 && selectedColumns.length !== 0 ? 2 : 1'>
                                                          {{rowKey[j] | format:selectedRows[j]}}</th>
                                                  </ng-container>
                                              </ng-container>
                                              <ng-container *ngIf="selectedRows.length && selectedRows.length < 6">
                                                  <th class="mdg-sr-cell width-0 no-padding no-border">&nbsp;</th>
                                              </ng-container>
                                              <ng-container *ngFor="let colKey of colKeys;let j = index">
                                                  <ng-container *ngFor="let v of selectedValues; let k = index">
                                                      <td [ngStyle]='getStyle(colKey)' (dblclick)='ShowDetail($event, rowKey, colKey, v, k)'>
                                                          {{tree[getKey(rowKey)][getKey(colKey)] !== undefined && tree[getKey(rowKey)][getKey(colKey)][v.column.colName + k] !== undefined ? v.column.valueField ? getAggrFValue(tree[getKey(rowKey)][getKey(colKey)][v.column.colName + k], v.column) : getAggrValue(tree[getKey(rowKey)][getKey(colKey)][v.column.colName
                                                          + k], v.column.colName, v.mathFn.funcName, v.column) : ""}}
                                                      </td>
                                                  </ng-container>
                                              </ng-container>
                                              <ng-container *ngFor="let v of selectedValues">
                                                  <td [ngStyle]='getStyle(v.column.valueField ? v.column.displayName : "Total " + v.mathFn.Name + " of " + v.column.displayName)' (dblclick)='ShowRowDetail($event, rowKey, v)'>
                                                      {{rowTotals[getKey(rowKey)] !== undefined ? v.column.valueField ? getAggrFValue(rowTotals[getKey(rowKey)], v.column) : getAggrValue(rowTotals[getKey(rowKey)], v.column.colName, v.mathFn.funcName, v.column) : ""}}</td>
                                              </ng-container>
                                          </tr>
                                          <tr>
                                              <ng-container *ngIf="selectedRows.length > 5">
                                                  <th title="{{getHeaderText('Grand Total')}}" [style.font-size]='selectedRows[0].cell.fontSize + "px"' [style.font-style]='selectedRows[0].cell.fontStyle' [style.font-weight]='selectedRows[0].cell.fontWeight' [class.text-right]='selectedRows[0].cell.textAlign === "right"'
                                                      [class.text-center]='selectedRows[0].cell.textAlign === "center"' class="title-format border-bottom-d9d9d9" *ngIf="selectedValues.length > 0" (click)="showGrandTotalFormatter('Grand Total')" [colSpan]="selectedRows.length + (selectedColumns.length === 0 ? 0 : 1)"
                                                      [ngStyle]="getHeaderStyle('Grand Total')">{{getHeaderText('Grand Total')}}
                                                  </th>
                                              </ng-container>
                                              <ng-container *ngIf="selectedRows.length < 6">
                                                  <th class="mdg-sr-cell width-0 no-padding no-border">&nbsp;</th>
                                              </ng-container>
                                              <ng-container *ngFor="let colKey of colKeys; let j = index;">
                                                  <ng-container *ngFor="let v of selectedValues">
                                                      <td [ngStyle]="getStyle('Grand Total')" (dblclick)='ShowColDetail($event, colKey, v)'>
                                                          {{colTotals[getKey(colKey)] !== undefined ? v.column.valueField ? getAggrFValue(colTotals[getKey(colKey)], v.column) : getAggrValue(colTotals[getKey(colKey)], v.column.colName, v.mathFn.funcName, v.column) : ""}}</td>
                                                  </ng-container>
                                              </ng-container>
                                              <ng-container *ngFor="let v of selectedValues;let k = index">
                                                  <td [ngStyle]="getStyle('Grand Total')" (dblclick)='ShowDetail($event, undefined, undefined, v, k)'>
                                                      {{v.column.valueField ? getAggrFValue(tData, v.column) : getAggrValue(tData, v.column.colName, v.mathFn.funcName, v.column)}}
                                                  </td>
                                              </ng-container>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </td>
                      </tr>
                  </table>
              </td>
          </tr>
      </table>
      <div *ngIf="chartType && chartType !== 'grid'">
          <div class="chart-filter">
              <div *ngFor="let col of selectedRows" class='btn btn-sm bn-default mdg-filter-item' (click)='showFilter(col)'>
                  <i class="mdg-filter fa fa-filter" *ngIf="pivotConfig.showColumnFilter"></i>
                  <span class="mdg-filter pull-left">{{col.displayName}}</span>
              </div>
              <div *ngFor="let col of selectedColumns" class='btn btn-sm bn-default mdg-filter-item' (click)='showFilter(col)'>
                  <i class="mdg-filter fa fa-filter" *ngIf="pivotConfig.showColumnFilter"></i>
                  <span class="mdg-filter pull-left">{{col.displayName}}</span>
              </div>
              <div *ngFor="let col of selectedFColumns" class='btn btn-sm bn-default mdg-filter-item' (click)='showFilter(col)'>
                  <i class="mdg-filter fa fa-filter" *ngIf="pivotConfig.showColumnFilter"></i>
                  <span class="mdg-filter pull-left">{{col.displayName}}</span>
              </div>
          </div>
          <div class='chart-container' *ngIf="chartData && chartData.length > 0">
              <canvas id="mdgChart" baseChart [datasets]="chartData" [labels]="chartLabels" [options]="chartOptions" [chartType]="chartType"></canvas>
          </div>
      </div>
      <div class="mdg-no-record" *ngIf="(data.length === 0 || (rowKeys.length <= 0 && colKeys.length <= 0)) && !processingData">
          <h3>{{noRecordsMessage}}</h3>
      </div>
      <div class="hidden">
          <table class="mdg-pivot" *ngIf="data.length > 0 && !processingData">
              <thead #pivotTableHeader>
                  <tr *ngFor="let col of selectedColumns; let j = index">
                      <th class="title-cell" *ngIf="j === 0 && selectedRows.length !== 0" colSpan="{{selectedRows.length}}" rowSpan="{{selectedColumns.length}}"></th>
                      <th class="title-cell">
                          <span class="mdg-filter pull-left">{{col.displayName}}</span>
                          <i *ngIf="pivotConfig.showColumnFilter" class="mdg-filter fa fa-filter" (click)='showFilter(col)'></i>
                      </th>
                      <ng-container *ngFor="let colKey of colKeys; let i = index">
                          <th class="title-value" [class.text-right]='col.headerAlign === "right"' [class.text-center]='col.headerAlign === "center"' *ngIf="getSpanSize(colKeys, i, j) !== -1" [colSpan]='getSpanSize(colKeys, i, j) * valLength' [rowSpan]='(j === (selectedColumns.length - 1) && selectedRows.length !== 0 && valLength === 1) ? 2 : 1 '>
                              {{getHeaderText(colKey[j]) | format:col}}</th>
                      </ng-container>
                      <ng-container *ngIf="j === 0">
                          <th class="title-value" [class.text-right]='sVal.column.headerAlign === "right"' [class.text-center]='sVal.column.headerAlign === "center"' *ngFor="let sVal of selectedValues" [rowSpan]="selectedColumns.length + (selectedRows.length === 0 && valLength <= 1 ? 0 : 1)">
                              {{getHeaderText(sVal.column.valueField ? sVal.column.displayName : "Total " + sVal.mathFn.Name + " of " + sVal.column.displayName)}}</th>
                      </ng-container>
                  </tr>
                  <tr *ngIf="selectedRows.length !== 0">
                      <th class="title-cell" *ngFor="let col of selectedRows; let j = index">
                          <span class="mdg-filter pull-left">{{col.displayName}}</span>
                          <i *ngIf="pivotConfig.showColumnFilter" class="mdg-filter fa fa-filter" (click)='showFilter(col)'></i>
                      </th>
                      <ng-container *ngIf="selectedColumns.length > 0">
                          <th class="title-cell"></th>
                      </ng-container>
                      <ng-container *ngIf="selectedColumns.length === 0">
                          <th class="title-value" [class.text-right]='sVal.column.headerAlign === "right"' [class.text-center]='sVal.column.headerAlign === "center"' *ngFor="let sVal of selectedValues">{{getHeaderText(sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)}}</th>
                      </ng-container>
                      <ng-container *ngIf="valLength > 1">
                          <ng-container *ngFor="let colKey of colKeys">
                              <th class="title-value" [class.text-right]='sVal.column.headerAlign === "right"' [class.text-center]='sVal.column.headerAlign === "center"' *ngFor="let sVal of selectedValues">{{getHeaderText(sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)}}</th>
                          </ng-container>
                      </ng-container>
                  </tr>
                  <tr *ngIf="selectedRows.length === 0 && valLength > 1">
                      <ng-container *ngIf="selectedColumns.length > 0">
                          <th class="title-cell"></th>
                      </ng-container>
                      <ng-container *ngIf="valLength > 1">
                          <ng-container *ngFor="let colKey of colKeys">
                              <th class="title-value" [class.text-right]='sVal.column.headerAlign === "right"' [class.text-center]='sVal.column.headerAlign === "center"' *ngFor="let sVal of selectedValues">{{getHeaderText(sVal.column.valueField ? sVal.column.displayName : sVal.mathFn.Name + " of " + sVal.column.displayName)}}</th>
                          </ng-container>
                      </ng-container>
                  </tr>
              </thead>
              <tbody #pivotTableBody>
                  <tr *ngFor="let rowKey of rowKeys; let i = index;">
                      <ng-container *ngFor="let rVal of rowKey; let j = index">
                          <th class="title-value" [class.text-right]='selectedRows[j].textAlign === "right"' [class.text-center]='selectedRows[j].textAlign === "center"' *ngIf="getSpanSize(rowKeys, i, j) !== -1" [rowSpan]='getSpanSize(rowKeys, i, j)' [colSpan]='j === selectedRows.length - 1 && selectedColumns.length !== 0 ? 2 : 1'>
                              {{rowKey[j] | format:selectedRows[j]}}</th>
                      </ng-container>
                      <ng-container *ngFor="let colKey of colKeys; let j = index;">
                          <ng-container *ngFor="let v of selectedValues; let k = index">
                              <td [class.text-right]='v.column.textAlign === "right"' [class.text-center]='v.column.textAlign === "center"' (dblclick)='ShowDetail($event, rowKey, colKey, v, k)'>
                                  {{tree[getKey(rowKey)][getKey(colKey)] !== undefined && tree[getKey(rowKey)][getKey(colKey)][v.column.colName + k] !== undefined ? v.column.valueField ? getAggrFValue(tree[getKey(rowKey)][getKey(colKey)][v.column.colName + k], v.column) : getAggrValue(tree[getKey(rowKey)][getKey(colKey)][v.column.colName
                                  + k], v.column.colName, v.mathFn.funcName, v.column) : ""}}
                              </td>
                          </ng-container>
                      </ng-container>
                      <ng-container *ngFor="let v of selectedValues">
                          <td [class.text-right]='v.column.textAlign === "right"' [class.text-center]='v.column.textAlign === "center"' (dblclick)='ShowRowDetail($event, rowKey, v)'>
                              {{rowTotals[getKey(rowKey)] !== undefined ? v.column.valueField ? getAggrFValue(rowTotals[getKey(rowKey)], v.column) : getAggrValue(rowTotals[getKey(rowKey)], v.column.colName, v.mathFn.funcName, v.column) : ""}}</td>
                      </ng-container>
                  </tr>
                  <tr>
                      <th *ngIf="selectedValues.length > 0" [colSpan]="selectedRows.length + (selectedColumns.length === 0 ? 0 : 1)">
                          <span class="mdg-value-filter pull-left" [ngStyle]="getGrandTotalStyle('Grand Total')">{{getHeaderText('Grand Total')}}</span>
                      </th>
                      <ng-container *ngFor="let colKey of colKeys;">
                          <ng-container *ngFor="let v of selectedValues">
                              <td [class.text-right]='v.column.textAlign === "right"' [class.text-center]='v.column.textAlign === "center"' (dblclick)='ShowColDetail($event, colKey, v)'>
                                  {{colTotals[getKey(colKey)] !== undefined ? v.column.valueField ? getAggrFValue(colTotals[getKey(colKey)], v.column) : getAggrValue(colTotals[getKey(colKey)], v.column.colName, v.mathFn.funcName, v.column) : ""}}
                              </td>
                          </ng-container>
                      </ng-container>
                      <ng-container *ngFor="let v of selectedValues;let k = index">
                          <td [class.text-right]='v.column.textAlign === "right"' [class.text-center]='v.column.textAlign === "center"' (dblclick)='ShowDetail($event, undefined, undefined, v, k)'>
                              {{v.column.valueField ? getAggrFValue(tData, v.column) : getAggrValue(tData, v.column.colName, v.mathFn.funcName, v.column)}}</td>
                      </ng-container>
                  </tr>
              </tbody>
          </table>
      </div>
  </div>`
})
export class MDGPivotDrawerComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() title: string = '';
  @Input() columns: Column[] = [];
  @Input() data: any[] = [];
  @Input() distValues: Distinct[] = [];
  @Input() formulas: MathFunction[] = [];
  @Input() selectedColumns: Column[] = [];
  @Input() selectedRows: Column[] = [];
  @Input() selectedValues: ValueField[] = [];
  @Input() selectedFColumns: Column[] = [];
  @Input() formattedFields: any = {};
  @Input() formulaFields: Column[] = [];
  @Input() filters: any[] = [];
  @Input() chartType: string = 'grid';
  @Input() noRecordsMessage: string = 'No data to display.';
  @Input() pivotConfig: PivotSave;

  @Output() loading: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  @Output() error: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('filter') filter: MDGFilterComponent;
  @ViewChild('formatter') formatter: MDGFormatterComponent;
  @ViewChild('datefilter') datefilter: MDGDateFilterComponent;
  @ViewChild('detail') detail: MDGDetailComponent;
  @ViewChild('pivotTableHeader') pivotTableHeader: ElementRef;
  @ViewChild('pivotTableBody') pivotTableBody: ElementRef;
  @ViewChild('hScroll') hScroll: ElementRef;
  @ViewChild('vScrollL') vScrollL: ElementRef;
  @ViewChild('vScrollR') vScrollR: ElementRef;
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  tData: any[] = [];
  rowKeys: any[] = [];
  colKeys: any[] = [];
  rowTotals: any[] = [];
  colTotals: any[] = [];
  tree: any[] = [];
  valLength = 1;

  chartOptions: any = {
    scaleShowVerticalLines: true,
    responsive: true,
    maintainAspectRatio: true,
    legend: {
      position: 'bottom'
    }
  };

  chartLabels: string[] = [];

  chartData: any[] = [];

  chartLegend: boolean = true;

  processingData: boolean = false;

  isDataFormatted: boolean = false;

  isSynchronizedScroll: boolean = false;

  eventsAdded: boolean = false;

  constructor(private cdRef: ChangeDetectorRef, private helper: HelperService, private sort: SortPipe, private aggr: AggrPipe, private format: FormatPipe, private zone: NgZone) { }

  ngOnInit() {
    this.checkInputFilter();
  }

  ngAfterViewInit() {
    this.zone.runOutsideAngular(() => {
      fromEvent(this.vScrollR.nativeElement, 'scroll')
        .subscribe(res => {
          this.onScroll(res);
        });
      fromEvent(this.vScrollL.nativeElement, 'scroll')
        .subscribe(res => {
          this.onLScroll(res);
        });
      fromEvent(this.hScroll.nativeElement, 'scroll')
        .subscribe(res => {
          this.onTScroll(res);
        });
    });
  }

  ngOnChanges(change: SimpleChanges) {
    if (change.filters !== undefined && change.filters.currentValue !== change.filters.previousValue) {
      this.checkInputFilter();
    }
  }

  checkInputFilter() {
    if (this.filters !== undefined && this.filters !== null && this.filters.length > 0) {
      this.filters.forEach(f => {
        const distValue = this.distValues.filter(m => m.col.colName === f.col);
        if (distValue.length > 0) {
          distValue[0].filter = f.filter;
          distValue[0].sort = f.sort;
        }
      });
    }
  }

  getTop() {
    return ((30 + (this.selectedColumns.length * 30) + ((this.selectedRows.length > 0 || this.valLength > 1) ? 30 : 0)) + 2) + 'px';
  }

  getLeft() {
    if (this.selectedRows.length < 6) {
      return ((40 + (this.selectedRows.length * 150) + (this.selectedColumns.length > 0 ? 150 : 0)) + 2) + 'px';
    } else {
      return '41px';
    }
  }

  isNumeric(input: any) {
    return typeof input === 'number';
  }

  updateChartType(charttype: any) {
    this.chartType = charttype.value;
    // if (this.chartType && this.chartType !== null && this.chartType.trim() !== '') {
    //     this.chartType = 'grid';
    // }
    this.detectChanges();
  }

  setData(data: any[], columns: Column[], rows: Column[], values: ValueField[], fColumns: Column[], fields: Column[], distValues: any[], cols: Column[], formats: any) {
    this.data = data;
    this.selectedColumns = columns;
    this.selectedRows = rows;
    this.selectedValues = values;
    this.selectedFColumns = fColumns;
    this.formulaFields = fields;
    this.formattedFields = formats;
    this.distValues = distValues;
    this.columns = cols;
    this.updateFilters();
    this.valLength = this.selectedValues.length === 0 ? 1 : this.selectedValues.length;
  }

  updateFilters() {
    const selRows = this.selectedRows.map(m => m.colName);
    const selCols = this.selectedColumns.map(m => m.colName);
    const selFCols = this.selectedFColumns.map(m => m.colName);
    this.filters = this.distValues.filter(f => (selRows.includes(f.col.colName) || selCols.includes(f.col.colName) || selFCols.includes(f.col.colName)))
      .map(m => {
        const filterValues = this.helper.copyArray(m.filter);
        if (m.col.dataType === 'date') {
          let i = 0;
          filterValues.forEach(() => {
            filterValues[i] = (new Date(filterValues[i])).toJSON();
            i++;
          });
        }
        return { 'col': m.col.colName, 'filterBy': m.filterBy, 'startDate': m.startDate, 'endDate': m.endDate, 'dataType': m.col.dataType, 'filter': filterValues, 'sort': m.sort };
      });
  }

  filterRecord(d: any) {
    let rMatch = true;
    this.filters.forEach(f => {
      if (f.dataType === 'date') {
        if (f.filterBy === 'list' && f.filter.length > 0 && f.filter.includes(d[f.col.toString()].toJSON())) {
          rMatch = false;
        } else if (d[f.col.toString()] <= f.startDate || d[f.col.toString()] >= f.endDate) {
          rMatch = false;
        }
      } else if (f.filter.length > 0 && f.filter.includes(d[f.col.toString()])) {
        rMatch = false;
      }
      return rMatch;
    });
    return rMatch;
  }

  formatData(d: any) {
    if (!this.isDataFormatted) {
      this.columns.filter(f => f.dataType === 'date').forEach(col => {
        d[col.colName.toString()] = new Date(d[col.colName.toString()]);
        d[col.colName + '-Day'] = (d[col.colName.toString()]).getDate();
        d[col.colName + '-Month'] = (d[col.colName.toString()]).getMonth();
        d[col.colName + '-Year'] = (d[col.colName.toString()]).getFullYear();
      });
    }
  }

  addFormulaField(d: any) {
    this.formulaFields.filter(f => f.valueField === false).forEach(field => {
      let formula = field.formula;
      field.fields.forEach(f => {
        if (f['colName']) {
          formula = formula.replace(f.colName.toString(), f.dataType === 'string' ? '"' + d[f.colName.toString()] + '"' : d[f.colName.toString()]);
          while (formula.includes(f.colName.toString())) {
            formula = formula.replace(f.colName.toString(), f.dataType === 'string' ? '"' + d[f.colName.toString()] + '"' : d[f.colName.toString()]);
          }
        } else {
          formula = formula.replace(f.toString(), d[f.toString()]);
          while (formula.includes(f.toString())) {
            formula = formula.replace(f.toString(), d[f.toString()]);
          }
        }
      });
      d[field.colName.toString()] = this.getValue(formula.toString());
    });
  }

  processRecord() {
    this.rowKeys = [];
    this.colKeys = [];
    this.rowTotals = [];
    this.colTotals = [];
    this.tree = [];
    this.tData = [];

    const tRowKeys: any[] = [];
    const tColKeys: any[] = [];
    const tRowTotals: any[] = [];
    const tColTotals: any[] = [];
    const tTree: any[] = [];
    const tTotalData: any[] = [];

    this.updateFilters();
    this.valLength = this.selectedValues.length === 0 ? 1 : this.selectedValues.length;
    this.data.forEach(d => {
      this.formatData(d);
      this.addFormulaField(d);
      if (this.filterRecord(d)) {
        tTotalData.push(d);
        let colKey: any, flatColKey: any, flatRowKey: any, l: any, len1: any, len2: any, n: any, ref: any, ref1: any, ref2: any, ref3: any, rowKey: any, x: any;
        colKey = [];
        rowKey = [];
        ref = this.selectedColumns.map(m => m.colName);
        for (l = 0, len1 = ref.length; l < len1; l++) {
          x = ref[l].toString();
          colKey.push((ref1 = d[x]) != null ? ref1 : 'null');
        }
        ref2 = this.selectedRows.map(m => m.colName);
        for (n = 0, len2 = ref2.length; n < len2; n++) {
          x = ref2[n].toString();
          rowKey.push((ref3 = d[x]) != null ? ref3 : 'null');
        }
        flatRowKey = rowKey.join(String.fromCharCode(0));
        flatColKey = colKey.join(String.fromCharCode(0));
        if (rowKey.length !== 0) {
          if (!tRowTotals[flatRowKey]) {
            tRowKeys.push(rowKey);
            tRowTotals[flatRowKey] = [];
          }
          tRowTotals[flatRowKey].push(d);
        }
        if (colKey.length !== 0) {
          if (!tColTotals[flatColKey]) {
            tColKeys.push(colKey);
            tColTotals[flatColKey] = [];
          }
          tColTotals[flatColKey].push(d);
        }
        if (colKey.length !== 0 && rowKey.length !== 0) {
          if (!tTree[flatRowKey]) {
            tTree[flatRowKey] = {};
          }
          if (!tTree[flatRowKey][flatColKey]) {
            tTree[flatRowKey][flatColKey] = {};
          }
          // tslint:disable-next-line:forin
          for (const v in this.selectedValues) {
            if (!tTree[flatRowKey][flatColKey][this.selectedValues[v].column.colName + v]) {
              tTree[flatRowKey][flatColKey][this.selectedValues[v].column.colName + v] = [];
            }
            tTree[flatRowKey][flatColKey][this.selectedValues[v].column.colName + v].push(d);
          }
        }
        if (colKey.length === 0 && rowKey.length > 0) {
          if (!tTree[flatRowKey]) {
            tTree[flatRowKey] = {};
          }
          // tslint:disable-next-line:forin
          for (const v in this.selectedValues) {
            if (!tTree[flatRowKey][this.selectedValues[v].column.colName + v]) {
              tTree[flatRowKey][this.selectedValues[v].column.colName + v] = [];
            }
            tTree[flatRowKey][this.selectedValues[v].column.colName + v].push(d);
          }
        }
        if (colKey.length > 0 && rowKey.length === 0) {
          if (!tTree[flatColKey]) {
            tTree[flatColKey] = {};
          }
          // tslint:disable-next-line:forin
          for (const v in this.selectedValues) {
            if (!tTree[flatColKey][this.selectedValues[v].column.colName + v]) {
              tTree[flatColKey][this.selectedValues[v].column.colName + v] = [];
            }
            tTree[flatColKey][this.selectedValues[v].column.colName + v].push(d);
          }
        }
      }
    });
    this.rowKeys = tRowKeys;
    this.colKeys = tColKeys;
    this.rowTotals = tRowTotals;
    this.colTotals = tColTotals;
    this.tree = tTree;
    this.tData = tTotalData;
    this.isDataFormatted = true;
  }

  getSpanSize(arr: any, i: any, j: any) {
    let l, len, n, noDraw, ref, ref1, stop, x;
    if (i !== 0) {
      noDraw = true;
      for (x = l = 0, ref = j;
        (0 <= ref ? l <= ref : l >= ref); x = 0 <= ref ? ++l : --l) {
        if (arr[i - 1][x] !== arr[i][x]) {
          noDraw = false;
        }
      }
      if (noDraw) {
        return -1;
      }
    }
    len = 0;
    while (i + len < arr.length) {
      stop = false;
      for (x = n = 0, ref1 = j;
        (0 <= ref1 ? n <= ref1 : n >= ref1); x = 0 <= ref1 ? ++n : --n) {
        if (arr[i][x] !== arr[i + len][x]) {
          stop = true;
        }
      }
      if (stop) {
        break;
      }
      len++;
    }
    return len;
  }

  getKey(key: any) {
    return key.join(String.fromCharCode(0));
  }

  getAggrChartFValue(value: any[], col: Column) {
    let formula = col.formula;
    col.fields.forEach(f => {
      const fvalue = this.aggr.transform(value.map(m => m[f.colName]), f.aggregation);
      let replaceContent = f.aggregation + '(' + f.colName + ')';
      replaceContent = replaceContent.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      formula = formula.replace(new RegExp(replaceContent, 'g'), fvalue);
    });
    const rData = this.getValue(formula.toString());
    return rData;
  }

  getAggrChartValue(value: any[], colName: string, fnName: string, col: Column) {
    const rData = this.aggr.transform(value.map(m => m[colName]), fnName);
    return rData;
  }

  getAggrFValue(value: any[], col: Column) {
    let formula = col.formula;
    col.fields.forEach(f => {
      const fvalue = this.aggr.transform(value.map(m => m[f.colName]), f.aggregation);
      let replaceContent = f.aggregation + '(' + f.colName + ')';
      replaceContent = replaceContent.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      formula = formula.replace(new RegExp(replaceContent, 'g'), fvalue);
    });
    const rData = this.getValue(formula.toString());
    return this.format.transform(rData, col);
  }

  getAggrValue(value: any[], colName: string, fnName: string, col: Column) {
    const rData = this.aggr.transform(value.map(m => m[colName]), fnName);
    return this.format.transform(rData, col);
  }

  showLoading() {
    this.zone.runOutsideAngular(() => {
      this.processingData = true;
      this.loading.emit(this.processingData);
    });
  }

  drawPivot() {
    try {
      this.processingData = true;
      setTimeout(() => {
        this.loading.emit(this.processingData);
      }, 10);
      setTimeout(() => {
        this.processRecord();
        if (this.chartType !== 'grid') {
          this.SetChartData();
        } else {
          setTimeout(() => {
            this.SetChartData();
          }, 10);
        }
        this.sortKeys();
        this.processingData = false;
        setTimeout(() => {
          this.loading.emit(this.processingData);
        }, 10);
        this.detectChanges();
      }, 250);
      this.detectChanges();
    } catch (ex) {
      this.error.emit(ex);
    }
  }

  SetChartData() {
    const cLabels: any[] = [];
    const cdata: any[] = [];
    this.rowKeys.forEach(rowKey => {
      let keyLabel = '';
      rowKey.forEach((rKey: any) => {
        keyLabel += (keyLabel.trim() === '' ? '' : ' - ') + this.getKeyValue(rKey);
      });
      cLabels.push(keyLabel);

      this.selectedValues.forEach(v => {
        const fData = cdata.filter(f => f !== null && f !== undefined && f.label === v.column.colName);
        let cData = { data: [0], label: v.column.colName };
        if (fData.length === 0) {
          cData.data = [];
          cdata.push(cData);
        } else {
          cData = fData[0];
        }

        if (this.rowTotals[this.getKey(rowKey)] !== undefined) {
          if (v.column.valueField) {
            cData.data.push(this.getAggrChartFValue(this.rowTotals[this.getKey(rowKey)], v.column));
          } else {
            cData.data.push(this.getAggrChartValue(this.rowTotals[this.getKey(rowKey)], v.column.colName.toString(), v.mathFn.funcName.toString(), v.column));
          }
        } else {
          cData.data.push(0);
        }
      });
    });
    this.chartLabels = cLabels;
    setTimeout(() => {
      this.chartData = cdata;
      this.detectChanges();
    }, 200);
    this.detectChanges();
  }

  getKeyValue(rKey: any) {
    return (rKey === null || rKey === undefined || rKey.toString().trim() === '' ? '[Empty]' : rKey);
  }

  showAddFilter(col: Column) {
    if (this.pivotConfig.showAdditionalFilter) {
      if (col.dataType === 'date') {
        this.datefilter.ShowFilter(col, this.distValues.filter(f => f.col.colName === col.colName)[0]);
      } else {
        this.filter.ShowFilter(col, this.distValues.filter(f => f.col.colName === col.colName)[0]);
      }
    }
  }

  showFilter(col: Column) {
    if (this.pivotConfig.showColumnFilter) {
      if (col.dataType === 'date') {
        this.datefilter.ShowFilter(col, this.distValues.filter(f => f.col.colName === col.colName)[0]);
      } else {
        this.filter.ShowFilter(col, this.distValues.filter(f => f.col.colName === col.colName)[0]);
      }
    }
  }

  onUpdateFilters(distValue: Distinct) {
    const obj = this.distValues.filter(f => f.col.colName === distValue.col.colName)[0];
    obj.endDate = distValue.endDate;
    obj.filter = distValue.filter;
    obj.filterBy = distValue.filterBy;
    obj.filterValue = distValue.filterValue;
    obj.sort = distValue.sort;
    obj.startDate = distValue.startDate;
    this.drawPivot();
  }

  sortKeys() {
    let r = 0;
    const rowObj: any = {};
    this.selectedRows.forEach(row => {
      const dObj = this.distValues.filter(f => f.col.colName === row.colName);
      if (dObj.length > 0) {
        rowObj[r] = (dObj[0].sort === '' ? 'skip' : dObj[0].sort);
      } else {
        rowObj[r] = 'skip';
      }
      r++;
    });
    this.rowKeys = this.sort.transformfields(this.rowKeys, rowObj);

    let c = 0;
    const colObj: any = {};
    this.selectedColumns.forEach(row => {
      const dObj = this.distValues.filter(f => f.col.colName === row.colName);
      if (dObj.length > 0) {
        colObj[c] = (dObj[0].sort === '' ? 'skip' : dObj[0].sort);
      } else {
        colObj[c] = 'skip';
      }
      c++;
    });
    this.colKeys = this.sort.transformfields(this.colKeys, colObj);
  }

  ShowDetail(sender: any, rowKey: any, colKey: any, valKey: ValueField, k: any) {
    if (sender.target.innerText !== '') {
      let data: any[] = [];
      let value: any = '';
      let flatRowKey: any = '', flatColKey: any = '', flatValKey: any = '';
      if (valKey !== undefined) {
        flatValKey = valKey.column.colName + (k !== undefined ? k : '0');
      }
      if (rowKey !== undefined) {
        flatRowKey = this.getKey(rowKey);
      }
      if (colKey !== undefined) {
        flatColKey = this.getKey(colKey);
      }
      if (rowKey !== undefined && colKey === undefined) {
        if (this.tree[flatRowKey] !== undefined && this.tree[flatRowKey][flatValKey] !== undefined) {
          data = this.tree[flatRowKey][flatValKey];
          value = valKey.column.valueField ? this.getAggrFValue(data, valKey.column) : this.getAggrValue(data, valKey.column.colName.toString(), valKey.mathFn.funcName.toString(), valKey.column);
        }
      } else if (rowKey === undefined && colKey !== undefined) {
        if (this.tree[flatColKey] !== undefined && this.tree[flatColKey][flatValKey] !== undefined) {
          data = this.tree[flatColKey][flatValKey];
          value = valKey.column.valueField ? this.getAggrFValue(data, valKey.column) : this.getAggrValue(data, valKey.column.colName.toString(), valKey.mathFn.funcName.toString(), valKey.column);
        }
      } else if (rowKey !== undefined && colKey !== undefined) {
        if (this.tree[flatRowKey] !== undefined && this.tree[flatRowKey][flatColKey] !== undefined && this.tree[flatRowKey][flatColKey][flatValKey] !== undefined) {
          data = this.tree[flatRowKey][flatColKey][flatValKey];
          value = valKey.column.valueField ? this.getAggrFValue(data, valKey.column) : this.getAggrValue(data, valKey.column.colName.toString(), valKey.mathFn.funcName.toString(), valKey.column);
        }
      } else {
        data = this.tData;
        value = valKey.column.valueField ? this.getAggrFValue(data, valKey.column) : this.getAggrValue(data, valKey.column.colName.toString(), valKey.mathFn.funcName.toString(), valKey.column);
      }
      setTimeout(() => {
        this.detail.ShowDetail(data, rowKey, colKey, valKey, value);
      }, 10);
    }
  }

  ShowRowDetail(sender: any, rowKey: any, valKey: ValueField) {
    if (sender.target.innerText !== '') {
      let data: any[] = [];
      let value: any = '';
      let flatRowKey: any = '';
      if (rowKey !== undefined) {
        flatRowKey = this.getKey(rowKey);
      }
      if (rowKey !== undefined) {
        if (this.rowTotals[flatRowKey] !== undefined) {
          data = this.rowTotals[flatRowKey];
          value = this.getAggrValue(data, valKey.column.colName.toString(), valKey.mathFn.funcName.toString(), valKey.column);
        }
      }
      setTimeout(() => {
        this.detail.ShowDetail(data, rowKey, '', valKey, value);
      }, 10);
    }
  }

  ShowColDetail(sender: any, colKey: any, valKey: ValueField) {
    if (sender.target.innerText !== '') {
      let data: any[] = [];
      let value: any = '';
      let flatColKey: any = '';
      if (colKey !== undefined) {
        flatColKey = this.getKey(colKey);
      }
      if (colKey !== undefined) {
        if (this.colTotals[flatColKey] !== undefined) {
          data = this.colTotals[flatColKey];
          value = this.getAggrValue(data, valKey.column.colName.toString(), valKey.mathFn.funcName.toString(), valKey.column);
        }
      }
      setTimeout(() => {
        this.detail.ShowDetail(data, '', colKey, valKey, value);
      }, 10);
    }
  }

  exportReport(reportType: any) {
    const fileName = this.title && this.title != null && this.title.trim() != '' ? this.title : 'Pivot';
    if (reportType === 'XLS') {
      if (this.chartType === 'grid' && this.pivotTableHeader !== undefined && this.pivotTableHeader.nativeElement !== null && this.pivotTableBody !== undefined && this.pivotTableBody.nativeElement !== undefined) {
        let pivotHeader = this.pivotTableHeader.nativeElement.innerHTML;
        let pivotBody = this.pivotTableBody.nativeElement.innerHTML;

        const pdfColCount = this.selectedRows.length + (this.selectedColumns.length > 0 ? 1 : 0) + (this.valLength > 0 ? this.colKeys.length * this.valLength : this.colKeys.length) + this.selectedValues.length;
        pivotHeader = '<tr><th colspan="' + pdfColCount + '">' + (this.title === null || this.title === undefined || this.title.trim() === '' ? '[No Title]' : this.title) + '</th></tr>' + pivotHeader;
        pivotHeader = pivotHeader.replace(/<th/g, '<th style="border-bottom:.5pt solid #696d72;border-top:.5pt solid #696d72;border-left:.5pt solid #696d72;border-right:.5pt solid #696d72; font-weight:bold;" ');

        pivotBody = pivotBody.replace(/<th/g, '<th style="border-bottom:.5pt solid #696d72;border-top:.5pt solid #696d72;border-left:.5pt solid #696d72;border-right:.5pt solid #696d72; font-weight:bold;" ');
        pivotBody = pivotBody.replace(/<td/g, '<td style="border-bottom:.5pt solid #696d72;border-top:.5pt solid #696d72;border-left:.5pt solid #696d72;border-right:.5pt solid #696d72;" ');

        const content = '<table><thead>' + pivotHeader + '</thead><tbody>' + pivotBody + '</tbody></table>';
        const a = document.createElement('a');
        const mimeType = 'application/xls';
        const blob = new Blob([content], { type: mimeType });
        const url = URL.createObjectURL(blob);
        a.href = url;
        a.setAttribute('download', fileName + '.xls');
        a.download = fileName + '.xls';
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        this.exportChartToPDF();
      }
    }
    if (reportType === 'PDF') {
      if (this.chartType === 'grid') {
        this.processingData = true;
        this.loading.emit(this.processingData);
        setTimeout(() => {
          try {
            pdfMake.createPdf(this.preparePDF()).download(fileName + '.pdf');
          } catch (ex) {
            this.error.emit('Error on exporting pivot data to pdf.');
          }
          this.processingData = false;
          this.loading.emit(this.processingData);
        }, 100);
      } else {
        this.exportChartToPDF();
      }
    }
    if (reportType === 'PRINT') {
      if (this.chartType === 'grid') {
        this.processingData = true;
        this.loading.emit(this.processingData);
        setTimeout(() => {
          try {
            pdfMake.createPdf(this.preparePDF()).print();
          } catch (ex) {
            this.error.emit('Error on printing pivot data.');
          }
          this.processingData = false;
          this.loading.emit(this.processingData);
        }, 100);
      } else {
        this.printChartToPDF();
      }
    }
    if (reportType === 'IMG') {
      if (this.chartType !== 'grid') {
        const chartCanvas = <HTMLCanvasElement>document.getElementById('mdgChart');
        const chartImage = chartCanvas !== null && chartCanvas ? chartCanvas.toDataURL('image/png') : '';
        const a = document.createElement('a');
        a.href = chartImage;
        a.setAttribute('download', fileName + '.png');
        a.download = fileName + '.png';
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    }
  }

  printChartToPDF() {
    this.processingData = true;
    this.loading.emit(this.processingData);
    setTimeout(() => {
      try {
        pdfMake.createPdf(this.getChartExportData()).print();
      } catch (ex) {
        this.error.emit('Error on printing pivot chart.');
      }
      this.processingData = false;
      this.loading.emit(this.processingData);
    }, 100);
  }

  exportChartToPDF() {
    this.processingData = true;
    this.loading.emit(this.processingData);
    setTimeout(() => {
      try {
        pdfMake.createPdf(this.getChartExportData()).download('Pivot.pdf');
      } catch (ex) {
        this.error.emit('Error on exporting pivot chart to pdf.');
      }
      this.processingData = false;
      this.loading.emit(this.processingData);
    }, 100);
  }

  getChartExportData() {
    const chartCanvas = <HTMLCanvasElement>document.getElementById('mdgChart');
    const chartImage = chartCanvas !== null && chartCanvas ? chartCanvas.toDataURL('image/png') : '';
    const chartContent = [
      {
        text: this.title !== undefined && this.title !== null && this.title !== '' ? this.title : '[No Title]',
        alignment: 'center',
        style: 'header'
      },
      {
        image: chartImage,
        width: 800,
        height: 400,
      }
    ];

    const pdfContent: any = {};
    pdfContent['content'] = chartContent;
    pdfContent['styles'] = this.helper.getStyleData();
    pdfContent['pageOrientation'] = 'landscape';
    pdfContent['pageSize'] = 'A4';
    pdfContent['pageMargins'] = [30, 30, 30, 30];
    return pdfContent;
  }

  preparePDF() {
    const rowCount = this.selectedRows.length;
    const colCount = this.selectedColumns.length;
    const body: any[] = [];
    let j = 0;
    let i = 0;
    let headerCells: any[] = [];
    this.selectedColumns.forEach(col => {
      headerCells = [];
      if (j === 0 && rowCount !== 0) {
        headerCells.push({
          text: '',
          style: 'tableCell',
          colSpan: rowCount,
          rowSpan: colCount
        });
        for (let c = 1; c < rowCount; c++) {
          headerCells.push({});
        }
      } else if (rowCount > 0) {
        this.selectedRows.forEach(() => {
          headerCells.push({});
        });
      }

      headerCells.push({
        text: col.displayName,
        style: 'tableCell',
        alignment: col.header ? col.header.textAlign : ''
      });

      i = 0;
      this.colKeys.forEach(colKey => {
        let colSpan = this.getSpanSize(this.colKeys, i, j);
        if (colSpan !== -1) {
          colSpan = colSpan * this.valLength;
          headerCells.push({
            text: this.format.transform(colKey[j], col),
            colSpan: colSpan,
            rowSpan: (j === (colCount - 1) && rowCount !== 0 && this.valLength === 1) ? 2 : 1,
            style: 'titleValue',
            alignment: col.header ? col.header.textAlign : ''
          });
          while (colSpan > 1) {
            headerCells.push({});
            colSpan--;
          }
        }
        i++;
      });
      this.selectedValues.forEach(sVal => {
        if (j === 0) {
          headerCells.push({
            text: sVal.column.valueField ? sVal.column.displayName : 'Total ' + sVal.mathFn.Name + ' of ' + sVal.column.displayName,
            rowSpan: colCount + (rowCount === 0 ? 0 : 1),
            style: 'titleValue',
            alignment: sVal.column.header ? sVal.column.header.textAlign : ''
          });
        } else {
          headerCells.push({});
        }
      });
      body.push(headerCells);
      j++;
    });
    let headerCount = j;
    if (rowCount !== 0) {
      headerCount++;
      headerCells = [];
      j = 0;
      this.selectedRows.forEach(col => {
        headerCells.push({
          text: col.displayName,
          style: 'tableCell',
          alignment: col.header ? col.header.textAlign : ''
        });
      });
      if (colCount > 0) {
        headerCells.push({});
      } else {
        this.selectedValues.forEach(sVal => {
          headerCells.push({
            text: sVal.column.valueField ? sVal.column.displayName : 'Total ' + sVal.mathFn.Name + ' of ' + sVal.column.displayName,
            style: 'titleValue',
            alignment: sVal.column.header ? sVal.column.header.textAlign : ''
          });
        });
      }
      this.colKeys.forEach(element => {
        if (this.valLength > 1) {
          this.selectedValues.forEach(sVal => {
            headerCells.push({
              text: sVal.column.valueField ? sVal.column.displayName : 'Total ' + sVal.mathFn.Name + ' of ' + sVal.column.displayName,
              style: 'titleValue',
              alignment: sVal.column.header ? sVal.column.header.textAlign : ''
            });
          });
        } else {
          headerCells.push({});
        }
      });
      if (colCount > 0) {
        this.selectedValues.forEach(sVal => {
          headerCells.push({});
        });
      }
      body.push(headerCells);
    }
    i = 0;
    this.rowKeys.forEach(rowKey => {
      headerCells = [];
      j = 0;
      rowKey.forEach(() => {
        const rowSpan = this.getSpanSize(this.rowKeys, i, j);
        if (rowSpan !== -1) {
          let colSpan = ((j === rowCount - 1) && colCount !== 0) ? 2 : 1;
          headerCells.push({
            text: this.format.transform(rowKey[j], this.selectedRows[j]),
            rowSpan: rowSpan,
            colSpan: colSpan,
            style: 'titleValue',
            alignment: this.selectedRows[j].cell ? this.selectedRows[j].cell.textAlign : ''
          });
          while (colSpan > 1) {
            headerCells.push({});
            colSpan--;
          }
        } else {
          headerCells.push({});
        }
        j++;
      });
      j = 0;
      this.colKeys.forEach(colKey => {
        let k = 0;
        this.selectedValues.forEach(v => {
          if (this.tree[this.getKey(rowKey)][this.getKey(colKey)] !== undefined && this.tree[this.getKey(rowKey)][this.getKey(colKey)][v.column.colName.toString() + k.toString()] !== undefined) {
            headerCells.push({
              text: v.column.valueField ? this.getAggrFValue(this.tree[this.getKey(rowKey)][this.getKey(colKey)][v.column.colName.toString() + k.toString()], v.column) : this.getAggrValue(this.tree[this.getKey(rowKey)][this.getKey(colKey)][v.column.colName.toString() + k.toString()], v.column.colName.toString(), v.mathFn.funcName.toString(), v.column),
              style: 'titleValue',
              alignment: v.column.cell ? v.column.cell.textAlign : ''
            });
          } else {
            headerCells.push({});
          }
          k++;
        });
      });

      this.selectedValues.forEach(v => {
        if (this.rowTotals[this.getKey(rowKey)] !== undefined) {
          headerCells.push({
            text: v.column.valueField ? this.getAggrFValue(this.rowTotals[this.getKey(rowKey)], v.column) : this.getAggrValue(this.rowTotals[this.getKey(rowKey)], v.column.colName.toString(), v.mathFn.funcName.toString(), v.column),
            style: 'titleValue',
            alignment: v.column.cell ? v.column.cell.textAlign : ''
          });
        }
      });
      body.push(headerCells);
      i++;
    });
    if (this.selectedValues.length > 0) {
      headerCells = [];
      if (this.valLength > 0) {
        let colSpan = rowCount + (colCount === 0 ? 0 : 1);
        headerCells.push({
          text: 'Grand Total',
          colSpan: colSpan,
          style: 'tableCell',
          alignment: 'right'
        });
        while (colSpan > 1) {
          headerCells.push({});
          colSpan--;
        }
      }
      this.colKeys.forEach(colKey => {
        this.selectedValues.forEach(v => {
          if (this.colTotals[this.getKey(colKey)] !== undefined) {
            headerCells.push({
              text: v.column.valueField ? this.getAggrFValue(this.colTotals[this.getKey(colKey)], v.column) : this.getAggrValue(this.colTotals[this.getKey(colKey)], v.column.colName.toString(), v.mathFn.funcName.toString(), v.column),
              style: 'titleValue',
              alignment: v.column.cell ? v.column.cell.textAlign : ''
            });
          } else {
            headerCells.push({});
          }
        });
      });
      this.selectedValues.forEach(v => {
        headerCells.push({
          text: v.column.valueField ? this.getAggrFValue(this.tData, v.column) : this.getAggrValue(this.tData, v.column.colName.toString(), v.mathFn.funcName.toString(), v.column),
          style: 'titleValue',
          alignment: v.column.cell ? v.column.cell.textAlign : ''
        });
      });
      body.push(headerCells);
    }

    const content: any[] = [];
    content.push({ text: this.title !== undefined && this.title !== null && this.title !== '' ? this.title : '[No Title]', alignment: 'center', style: 'header' });
    const table: any = {};
    table['headerRows'] = headerCount;
    table['body'] = body;
    content.push({ style: 'table', table: table });

    const pdfContent: any = {};
    pdfContent['content'] = content;
    pdfContent['styles'] = this.helper.getStyleData();
    const pdfColCount = rowCount + (colCount > 0 ? 1 : 0) + (this.valLength > 0 ? this.colKeys.length * this.valLength : this.colKeys.length) + this.selectedValues.length;
    const pageInfo = this.helper.getPageInfo(pdfColCount);
    pdfContent['pageOrientation'] = pageInfo.pageOrientation;
    pdfContent['pageSize'] = pageInfo.pageSize;
    pdfContent['pageMargins'] = [20, 20, 20, 20];
    return pdfContent;
  }

  onTScroll(event: any) {
    // console.log('on Top Scroll `' + this.isSynchronizedScroll + '`');
    if (!this.isSynchronizedScroll) {
      this.isSynchronizedScroll = true;
      this.vScrollR.nativeElement.scrollLeft = event.target.scrollLeft;
    } else {
      this.isSynchronizedScroll = false;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
  }

  onLScroll(event: any) {
    // console.log('on Left Scroll `' + this.isSynchronizedScroll + '`');
    if (!this.isSynchronizedScroll) {
      this.isSynchronizedScroll = true;
      this.vScrollR.nativeElement.scrollTop = event.target.scrollTop;
    } else {
      this.isSynchronizedScroll = false;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
  }

  onScroll(event: any) {
    // console.log('on Scroll `' + this.isSynchronizedScroll + '`');
    if (!this.isSynchronizedScroll) {
      this.isSynchronizedScroll = true;
      this.hScroll.nativeElement.scrollLeft = event.target.scrollLeft;
      this.vScrollL.nativeElement.scrollTop = event.target.scrollTop;
    } else {
      this.isSynchronizedScroll = false;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
  }

  getValue(formula: any) {
    return (new Function('return ' + formula))();
  }

  showColFormatter(col: Column, colKey: any, j: any) {
    const objArr = [];
    for (let i = 0; i <= j; i++) {
      objArr.push(colKey[i]);
    }
    this.formatter.ShowFormat(col, objArr);
  }

  showFormatter(col: Column, colKey: any) {
    this.formatter.ShowFormat(col, colKey);
  }

  showGrandTotalFormatter(colName: string) {
    const col = new Column();
    col.colName = colName;
    col.cell = undefined;
    col.header = undefined;
    this.formatter.ShowFormat(col, colName);
  }

  onUpdateFormatter(event: any) {
    this.formattedFields[event.flatKeyValue] = event;
    this.detectChanges();
  }

  getColHeaderStyle(colKey: any, j: any) {
    const objArr = [];
    for (let i = 0; i <= j; i++) {
      objArr.push(colKey[i]);
    }
    return this.getHeaderStyle(objArr);
  }

  getHeaderStyle(colKey: any) {
    const flatColKey = colKey instanceof Array ? colKey.join(String.fromCharCode(0)) : colKey;
    let obj: FieldStyle;
    if (this.formattedFields[flatColKey]) {
      obj = this.formattedFields[flatColKey].header;
    } else {
      obj = this.helper.getHeaderStyle();
    }
    return {
      'font-size': obj.fontSize + 'px',
      'font-style': obj.fontStyle,
      'font-weight': obj.fontWeight,
      'text-align': obj.textAlign,
      'text-orientation': obj.textOrientation
    };
  }

  getGrandTotalStyle(colKey: any) {
    const flatColKey = colKey instanceof Array ? colKey.join(String.fromCharCode(0)) : colKey;
    let obj: FieldStyle;
    if (this.formattedFields[flatColKey]) {
      obj = this.formattedFields[flatColKey].header;
    } else {
      obj = this.helper.getGrandTotalStyle();
    }
    return {
      'font-size': obj.fontSize + 'px',
      'font-style': obj.fontStyle,
      'font-weight': obj.fontWeight,
      'text-align': obj.textAlign,
      'text-orientation': obj.textOrientation
    };
  }

  getHeaderText(colKey: any) {
    const flatColKey = colKey instanceof Array ? colKey.join(String.fromCharCode(0)) : colKey;
    const obj = this.formattedFields[flatColKey];
    if (obj && obj !== null && obj.displayName && obj.displayName !== null && obj.displayName !== '') {
      return obj.displayName;
    }
    return colKey;
  }

  getStyle(colKey: any) {
    const flatColKey = colKey instanceof Array ? colKey.join(String.fromCharCode(0)) : colKey;
    let obj: FieldStyle;
    if (this.formattedFields[flatColKey]) {
      obj = this.formattedFields[flatColKey].cell;
    } else {
      obj = this.helper.getCellStyle();
    }
    return {
      'font-size': obj.fontSize + 'px',
      'font-style': obj.fontStyle,
      'font-weight': obj.fontWeight,
      'text-align': obj.textAlign,
      'text-orientation': obj.textOrientation
    };
  }

  detectChanges() {
    setTimeout(() => {
      if (
        this.cdRef !== null &&
        this.cdRef !== undefined &&
        !(this.cdRef as ViewRef).destroyed
      ) {
        this.cdRef.detectChanges();
      }
    }, 250);
  }
}
